module.exports = __webpack_public_path__ + "31884d3bf37ff64515527bb5e4431460.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MM.svg
// module id = NShS
// module chunks = 0